'use strict';

var tslib_es6 = require('./tslib.es6-cce58b3a.js');
var cookies = require('./cookies-46b3ee01.js');
var _commonjsHelpers = require('./_commonjsHelpers-3fc1f64e.js');

/*
 * @Date: 2022-06-06 08:40:48
 * @Author: manuelzhao
 * @LastEditors: manuelzhao
 * @LastEditTime: 2022-06-06 08:41:16
 * @Description: 判断UA
 * @FilePath: /calendar-create-app/utils/get-user-agent.ts
 */
/**
 * 获取UserAgent
 * @param ctx
 */
function getNextUserAgent(ctx) {
  var _a;
  var userAgent = '';
  if (cookies.isServer) {
    userAgent = ((_a = ctx === null || ctx === void 0 ? void 0 : ctx.req) === null || _a === void 0 ? void 0 : _a.headers['user-agent']) || '';
  } else {
    userAgent = window.navigator.userAgent;
  }
  return userAgent;
}
var getUserAgent = getNextUserAgent;

/**
 * 腾讯会议App
 */
var isWeMeetApp = function (userAgent) {
  return /app\/tencent_wemeet/i.test(userAgent.toLowerCase());
};
/**
 * Windows 系统
 */
var isWin = function (userAgent) {
  return /windows|win32|win64/i.test(userAgent.toLowerCase());
};
/**
 * mac 系统
 */
var isMac = function (userAgent) {
  return /macintosh|mac os x/i.test(userAgent.toLowerCase());
};
/**
 * 安卓
 */
var isAndroid = function (userAgent) {
  return /android|adr/i.test(userAgent.toLowerCase());
};
/**
 * IOS
 */
var isIOS = function (userAgent) {
  return /iphone|ipod|ipad/i.test(userAgent.toLowerCase());
};
/**
 * iPhone
 */
var isIPhone = function (userAgent) {
  return /iphone/i.test(userAgent.toLowerCase());
};
/**
 * iPad
 */
var isIPad = function (userAgent) {
  return /ipad/i.test(userAgent.toLowerCase());
};
/**
 * Windows App
 */
var isWinApp = function (userAgent) {
  return isWin(userAgent) && isWeMeetApp(userAgent);
};
/**
 * mac App
 */
var isMacApp = function (userAgent) {
  return !isIOS(userAgent) && isMac(userAgent) && isWeMeetApp(userAgent);
};

/**
 终端类型定义
 enum InstanceType {
  kInstanceTypeNone         = 0,
  kInstanceTypeWin          = 1,    // PC - windows
  kInstanceTypeMac          = 2,    // Mac
  kInstanceTypeAndroid      = 3,    // Android
  kInstanceTypeIPhone       = 4,    // iPhone
  kInstanceTypeWeb          = 5,    // web
  kInstanceTypeIPad         = 6,    // iPad
  kInstanceTypeAPad         = 7,    // aPad
  kInstanceTypeMiniProgram  = 8,    // wechat mini program
};
 */
/**
  * Instance Id定义映射
  */
var InstanceTypeMap = {
  0: 'None',
  1: 'Windows',
  2: 'Mac',
  3: 'Android',
  4: 'iPhone',
  5: 'Web',
  6: 'iPad',
  7: 'aPad',
  8: 'wxProgram'
};
/**
  * 判断终端平台类型
  * @param userAgent UA
  */
function getInstanceId(userAgent) {
  var id = 0;
  if (isWinApp(userAgent)) {
    id = 1;
  } else if (isMacApp(userAgent)) {
    id = 2;
  } else if (isAndroid(userAgent) && isWeMeetApp(userAgent)) {
    id = 3;
  } else if (isIPhone(userAgent) && isWeMeetApp(userAgent)) {
    id = 4;
  } else if (!isWeMeetApp(userAgent)) {
    id = 5;
  } else if (isIPad(userAgent) && isWeMeetApp(userAgent)) {
    id = 6;
  }
  return {
    id: id,
    name: InstanceTypeMap[id] || ''
  };
}

/**
 * 腾讯会议内部版本号
 */
function tencentAppVersion(userAgent) {
  var _a;
  var res = '';
  var ua = userAgent.toLowerCase();
  // 不是企业微信
  var regStrSaf = /app_version\/[\d._]*/gi;
  var verinfo = ua.match(regStrSaf);
  if (verinfo && verinfo.length > 0) {
    _a = verinfo[0].split('/'), res = _a[1];
  }
  return res;
}

var os = _commonjsHelpers.createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, '__esModule', {
    value: true
  });

  // import { compareVersion } from '../compare-version';
  /**
   * 腾讯日历App
   */
  var isCalendarApp = function (userAgent) {
    return /app\/tencent_wecalendar/i.test(userAgent.toLowerCase());
  };
  /**
   * Windows 系统
   */
  var isWin = function (userAgent) {
    return /windows|win32|win64/i.test(userAgent.toLowerCase());
  };
  /**
   * mac 系统
   */
  var isMac = function (userAgent) {
    return /macintosh|mac os x/i.test(userAgent.toLowerCase());
  };
  /**
   * 安卓
   */
  var isAndroid = function (userAgent) {
    return /android|adr/i.test(userAgent.toLowerCase());
  };
  /**
   * IOS
   */
  var isIOS = function (userAgent) {
    return /iphone|ipod|ipad/i.test(userAgent.toLowerCase());
  };
  /**
   * iPhone
   */
  var isIPhone = function (userAgent) {
    return /iphone/i.test(userAgent.toLowerCase());
  };
  /**
   * iPad
   */
  var isIPad = function (userAgent) {
    return /ipad/i.test(userAgent.toLowerCase());
  };
  /**
   * Windows App
   */
  var isWinApp = function (userAgent) {
    return isWin(userAgent) && isCalendarApp(userAgent);
  };
  /**
   * mac App
   */
  var isMacApp = function (userAgent) {
    return !isIOS(userAgent) && isMac(userAgent) && isCalendarApp(userAgent);
  };
  /**
   * ie 10
   */
  var isIE10 = function (navigator) {
    return navigator.appName === 'Microsoft Internet Explorer' && parseInt(navigator.appVersion.split(';')[1].replace(/[ ]/g, '').replace('MSIE', ''), 10) === 10;
  };
  /**
   * 微信浏览器
   */
  var isWeChat = function (ua) {
    return /micromessenger/i.test(ua) && !/wxwork/i.test(ua);
  };
  /**
   * 企业微信
   */
  var isWxwork = function () {
    return navigator.userAgent.toLowerCase().indexOf('wxwork') !== -1;
  };
  /*
   * 企业微信私有化
   */
  var isWxworkLocal = function () {
    return navigator.userAgent.toLowerCase().indexOf('wxworklocal') !== -1;
  };
  /**
   * Saas企业微信（非私有化企业微信）
   */
  var isWxWorkSaas = function () {
    return isWxwork() && !isWxworkLocal();
  };
  /**
   * Determine whether QBCore version of the web browser embedded in the WeiXin PC client
   * is less than the given parameter QBCoreVer.
   * @param QBCoreVer the QBCore version you want do compare against
   */
  // export const isWeiXinQBCoreLt = (QBCoreVer: any) => {
  //   const { userAgent } = window.navigator;
  //   const qbCoreInfo = userAgent.match(/QBCore\/([\d.]+)/i);
  //   const isWeiXin = /MicroMessenger/i.test(userAgent);
  //   return isWeiXin
  //     && !userAgent.includes('wxwork')
  //     && qbCoreInfo
  //     && qbCoreInfo.length >= 2
  //     && compareVersion(qbCoreInfo[1], QBCoreVer) < 0;
  // };
  /**
   * 企业微信的userAgent：Mozilla/5.0 (Linux; Android 9; Pixel 2 Build/PQ2A.190405.003; wv)
   * AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/66.0.3359.126
   * MQQBrowser/6.2 TBS/044605 Mobile Safari/537.36 wxwork/2.7.8 MicroMessenger/7.0.1 NetType/WIFI Language/zh
   */
  // export const isWeiXinGte656 = () => {
  //   const { userAgent } = window.navigator;
  //   const wxInfo = userAgent.match(/MicroMessenger\/([\d.]+)/i);
  //   return (
  //     !userAgent.includes('wxwork')
  //     && wxInfo
  //     && wxInfo.length >= 2
  //     && compareVersion(wxInfo[1], '6.5.6') >= 0
  //   );
  // };
  /**
   * 企业微信版本是否大于3.1.2
   */
  var isWxWorkGte312 = function () {
    var userAgent = window.navigator.userAgent;
    var wxInfo = userAgent.match(/wxwork\/([\d.]+)/i);
    console.log('>>>>wxInfo', wxInfo);
    return userAgent.includes('wxwork') && wxInfo && wxInfo.length >= 2 && wxInfo[1] >= '3.1.2';
  };
  var getOsName = function () {
    /**
     * windows
     */
    if (navigator.appVersion.includes('Win')) {
      return 'windows';
    }
    if (navigator.appVersion.includes('Android')) {
      return 'android';
    }
    /**
     * ios
     */
    // iOS和Mac的顺序不能变，经测试发现Mac的浏览器里会有iOS的字样
    if (navigator.appVersion.includes('iPhone') || navigator.appVersion.includes('iPad')) {
      return 'ios';
    }
    /**
     * mac
     */
    var isMac = navigator.platform === 'Mac68K' || navigator.platform === 'MacPPC' || navigator.platform === 'Macintosh' || navigator.platform === 'MacIntel' || navigator.appVersion.includes('Mac');
    if (isMac) {
      return 'mac';
    }
    if (navigator.userAgent.includes('Linux')) {
      return 'linux';
    }
    return 'unknown';
  };
  /**
   * Linux 系统
   */
  var isLinux = function () {
    var os = getOsName();
    if (os === 'linux') {
      return true;
    }
    return false;
  };
  var isWindowsWechat = function () {
    return /WindowsWechat/.test(navigator.userAgent);
  };
  var isEdge = function () {
    return /Edge/.test(navigator.userAgent);
  };
  var isFF = function () {
    return navigator.userAgent.toLowerCase().indexOf('firefox') !== -1;
  };
  var isIE = function () {
    return /Trident/.test(navigator.userAgent);
  };
  /**
   * 企业微信安卓版
   */
  var isWxworkInAndroid = function (ua) {
    return /Android/i.test(ua) && /wxwork/i.test(ua);
  };
  /**
   * 获取系统的版本号：windows、android、mac、ios
   */
  var getSystemVersion = function () {
    var os = getOsName();
    var userAgent = window.navigator.userAgent;
    var info = null;
    if (os === 'windows') {
      info = userAgent.toLocaleLowerCase().match(/windows nt ([\d.]+)/i);
    } else if (os === 'android') {
      info = userAgent.toLocaleLowerCase().match(/android ([\d.]+)/i);
    } else if (os === 'mac') {
      info = userAgent.toLocaleLowerCase().replace(/_/g, '.').match(/mac os x ([\d.]+)/i);
    } else if (os === 'ios') {
      info = userAgent.toLocaleLowerCase().replace(/_/g, '.').match(/os ([\d.]+)/i);
    } else {
      return 'unknown';
    }
    return info && info.length >= 2 && info[1] || 'unknown';
  };
  /**
   * 获取设备语言，目前仅支持：繁体中文、简体中文、英语
   */
  var getSystemLanguage = function () {
    var language = navigator.language.toLocaleLowerCase();
    if (language === 'zh-tw' || language === 'zh-hk' || language === 'zh-mo') {
      return '繁体中文';
    }
    if (language.indexOf('zh') > -1) {
      return '简体中文';
    }
    if (language.indexOf('en') > -1) {
      return '英语';
    }
    return 'unknown';
  };
  /**
   * 获取系统时区
   */
  var getSystemTimeZone = function () {
    if (Intl) {
      var arr = new Date().toTimeString().split(' ');
      var str = arr[2].substring(1, arr[2].length - 1);
      var timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone.split('/');
      return "(".concat(arr[1], ")").concat(str, "-").concat(timeZone[1]);
    }
    return 'unknown';
  };
  // 是否搜狗浏览器
  var isSe = function (userAgent) {
    return /se\s2\.x/i.test(userAgent.toLowerCase());
  };
  var isSafari = function (userAgent) {
    var ua = userAgent.toLowerCase();
    var fd = function (ss) {
      return ua.indexOf(ss) > -1;
    };
    var nf = function (ss) {
      return ua.indexOf(ss) === -1;
    };
    var a = fd('safari/');
    var b = nf('chrome/');
    var c = nf('qq/') && nf('mqqbrowser');
    return a && b && c;
  };
  var isMobile = function () {
    if (isSafari(navigator.userAgent) && navigator.maxTouchPoints) {
      // some iPads just does not have `iPad` in UA
      return true;
    }
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  };
  // warn: iPad 13.5 系统会判断为false
  var isMobileServer = function (ua) {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
  };
  var isMeetingApp = function () {
    return !!navigator.userAgent.match(/app\/tencent_wemeet/);
  };
  exports.getOsName = getOsName;
  exports.getSystemLanguage = getSystemLanguage;
  exports.getSystemTimeZone = getSystemTimeZone;
  exports.getSystemVersion = getSystemVersion;
  exports.isAndroid = isAndroid;
  exports.isCalendarApp = isCalendarApp;
  exports.isEdge = isEdge;
  exports.isFF = isFF;
  exports.isIE = isIE;
  exports.isIE10 = isIE10;
  exports.isIOS = isIOS;
  exports.isIPad = isIPad;
  exports.isIPhone = isIPhone;
  exports.isLinux = isLinux;
  exports.isMac = isMac;
  exports.isMacApp = isMacApp;
  exports.isMeetingApp = isMeetingApp;
  exports.isMobile = isMobile;
  exports.isMobileServer = isMobileServer;
  exports.isSafari = isSafari;
  exports.isSe = isSe;
  exports.isWeChat = isWeChat;
  exports.isWin = isWin;
  exports.isWinApp = isWinApp;
  exports.isWindowsWechat = isWindowsWechat;
  exports.isWxWorkGte312 = isWxWorkGte312;
  exports.isWxWorkSaas = isWxWorkSaas;
  exports.isWxwork = isWxwork;
  exports.isWxworkInAndroid = isWxworkInAndroid;
  exports.isWxworkLocal = isWxworkLocal;
});
_commonjsHelpers.unwrapExports(os);
os.getOsName;
os.getSystemLanguage;
os.getSystemTimeZone;
os.getSystemVersion;
os.isAndroid;
var os_6 = os.isCalendarApp;
os.isEdge;
os.isFF;
os.isIE;
os.isIE10;
os.isIOS;
os.isIPad;
os.isIPhone;
os.isLinux;
os.isMac;
os.isMacApp;
os.isMeetingApp;
os.isMobile;
os.isMobileServer;
os.isSafari;
os.isSe;
os.isWeChat;
os.isWin;
os.isWinApp;
os.isWindowsWechat;
os.isWxWorkGte312;
os.isWxWorkSaas;
os.isWxwork;
os.isWxworkInAndroid;
os.isWxworkLocal;

var randomString_1 = _commonjsHelpers.createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, '__esModule', {
    value: true
  });

  /**
   * 生成随机字符串，默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1
   * @param len 要生成字符串的长度
   */
  function randomString(len) {
    if (len === void 0) {
      len = 9;
    }
    var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
    var string = '';
    for (var i = 0; i < len; i++) {
      string += chars[Math.floor(Math.random() * chars.length)];
    }
    return string;
  }
  exports.randomString = randomString;
});
_commonjsHelpers.unwrapExports(randomString_1);
var randomString_2 = randomString_1.randomString;

var getToken = function (allCookies) {
  var token = '';
  // 多层保存避免token拿不到
  if (typeof window !== 'undefined') {
    token = window.currentTicket;
  }
  if (!token && typeof sessionStorage !== 'undefined') {
    token = sessionStorage.getItem('ticket');
  }
  return token || allCookies.ticket || allCookies.we_meet_token || allCookies.token;
};
// 获取uid和appid
var getIdSafe = function (key) {
  var token = '';
  // 多层保存避免token拿不到
  if (typeof window !== 'undefined') {
    // @ts-ignore
    token = window["safe_id_".concat(key)];
  }
  if (!token && typeof sessionStorage !== 'undefined') {
    token = sessionStorage.getItem("safe_id_".concat(key));
  }
  return token;
};
var getReqConfig = (function (ctx, token, getNextUa, getCookies) {
  return tslib_es6.__awaiter(void 0, void 0, void 0, function () {
    var userAgent, allCookies, instanceId, cToken, appId, appUid, queryParams, config, cookies$1, pathUrl, referer;
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return tslib_es6.__generator(this, function (_j) {
      userAgent = (getNextUa || getUserAgent)(ctx);
      allCookies = (getCookies || cookies.getAllCookies)(ctx) || {};
      instanceId = getInstanceId(userAgent);
      cToken = token || getToken(allCookies);
      appId = getIdSafe('appId') || allCookies.app_id || ((_a = ctx === null || ctx === void 0 ? void 0 : ctx.query) === null || _a === void 0 ? void 0 : _a.app_id) || allCookies.corp_id || '';
      appUid = getIdSafe('appUid') || allCookies.app_uid || ((_b = ctx === null || ctx === void 0 ? void 0 : ctx.query) === null || _b === void 0 ? void 0 : _b.app_uid) || '';
      queryParams = {
        c_instance_id: instanceId.id || '5',
        c_os_model: 'web',
        c_os: 'web',
        c_nonce: randomString_2(8),
        c_os_version: encodeURIComponent(userAgent),
        c_timestamp: +new Date(),
        c_app_id: appId,
        c_app_uid: appUid,
        c_platform: os_6(userAgent) || isWeMeetApp(userAgent) ? '5' : '0',
        c_token: cToken,
        c_app_version: allCookies.app_version || allCookies.app_version || tencentAppVersion(userAgent) || '',
        platform: instanceId.name || 'web',
        app_id: appId,
        c_lang: ((_c = ctx === null || ctx === void 0 ? void 0 : ctx.query) === null || _c === void 0 ? void 0 : _c.lang) || 'zh-CN'
      };
      config = {
        params: queryParams
      };
      if (cookies.isServer && ctx) {
        cookies$1 = ((_e = (_d = ctx.req) === null || _d === void 0 ? void 0 : _d.headers) === null || _e === void 0 ? void 0 : _e.cookie) || '';
        pathUrl = (_f = ctx.req) === null || _f === void 0 ? void 0 : _f.url;
        referer = ((_h = (_g = ctx.req) === null || _g === void 0 ? void 0 : _g.headers) === null || _h === void 0 ? void 0 : _h.referer) || '';
        config.headers = {
          Cookie: cookies$1,
          Referer: referer || "https://meeting.tencent.com".concat(pathUrl),
          // @ts-ignore
          'app-uid': appUid,
          // @ts-ignore
          'app-id': appId,
          platform: 'web' // web表明是h5来的请求
        };
      }

      return [2 /*return*/, config];
    });
  });
});

/*
 * @Date: 2022-05-27 17:29:57
 * @Author: manuelzhao
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2023-03-12 23:34:44
 * @Description: 获取北极星配置
 * @FilePath: /calendar-framework/packages/request/polaris/index.ts
 */
/**
 * 通过路径与获取L5配置
 * @param path 路径
 */
var getPolarisConfig = function (path) {
  var _a, _b;
  // @ts-ignore
  var polarisMap = ((_b = (_a = process === null || process === void 0 ? void 0 : process.env) === null || _a === void 0 ? void 0 : _a.pugins) === null || _b === void 0 ? void 0 : _b.request) || polarisMap;
  var config = polarisMap.find(function (_a) {
    var prefix = _a.prefix;
    return path.startsWith(prefix);
  });
  if (config === null || config === void 0 ? void 0 : config.polaris) {
    // 通过域名匹配对应L5
    var deployEnv = process.env.DEPLOY_ENV || 'production';
    var polarisConfig = config.polaris[deployEnv];
    // logger.info('polarisConfig: %j', polarisConfig);
    return {
      webPrefix: config.prefix,
      polarisConfig: polarisConfig
    };
  }
  return {};
};

var emptyCallBack = function () {};
var isServer = typeof window === 'undefined';
/**
 * 根据域名获取cgi地址
 * @param ctx
 * @returns
 */
var getCgiDomain = function (ctx) {
  var _a, _b;
  var hostName = (_b = (_a = ctx === null || ctx === void 0 ? void 0 : ctx.req) === null || _a === void 0 ? void 0 : _a.headers) === null || _b === void 0 ? void 0 : _b.host;
  if (!isServer) {
    hostName = location.host;
  }
  // 特殊逻辑
  if (hostName === 'source.meeting.qq.com') {
    return 'meeting.tencent.com';
  }
  return hostName;
};
function getServerUrl(path, hostName, consumer) {
  return tslib_es6.__awaiter(this, void 0, void 0, function () {
    var _a, webPrefix, polarisConfig, polaris, isCICD, metaData, response_1, _b, host, port;
    return tslib_es6.__generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          if (!consumer) return [3 /*break*/, 2];
          _a = getPolarisConfig(path), webPrefix = _a.webPrefix, polarisConfig = _a.polarisConfig;
          polaris = polarisConfig;
          if (!(polaris && webPrefix)) return [3 /*break*/, 2];
          isCICD = process.env.DEPLOY_ENV === 'ci';
          metaData = {};
          if (isCICD) {
            metaData = {
              env: process.env.env
            };
          }
          return [4 /*yield*/, consumer.select(polaris.namespace, polaris.service, metaData)];
        case 1:
          response_1 = _c.sent();
          if (!response_1) {
            return [2 /*return*/, {
              url: "http://".concat(polaris.default),
              callback: emptyCallBack
            }];
          }
          _b = response_1.instance, host = _b.host, port = _b.port;
          return [2 /*return*/, {
            url: "http://".concat(host, ":").concat(port).concat(path.replace(webPrefix, '')),
            callback: function (success, cost, code) {
              response_1.update(success, cost, code);
            }
          }];
        case 2:
          // 获取配置失败
          return [2 /*return*/, {
            url: "https://".concat(hostName).concat(path),
            callback: emptyCallBack
          }];
      }
    });
  });
}
var getUrl = function (_a) {
  var _b = _a.prefix,
    prefix = _b === void 0 ? '/' : _b,
    path = _a.path,
    ctx = _a.ctx,
    getHostName = _a.getHostName,
    consumer = _a.consumer;
  return tslib_es6.__awaiter(void 0, void 0, void 0, function () {
    var p, hostName, protocol;
    return tslib_es6.__generator(this, function (_c) {
      p = "".concat(prefix).concat(path);
      hostName = (getHostName || getCgiDomain)(ctx);
      protocol = 'https://';
      if (prefix.match(/http(s)?:\/\//)) {
        return [2 /*return*/, {
          url: "".concat(prefix).concat(path),
          callback: emptyCallBack
        }];
      }
      // browser
      if (!isServer || !ctx) {
        return [2 /*return*/, {
          url: "".concat(protocol).concat(hostName).concat(p),
          callback: emptyCallBack
        }];
      }
      // server product
      return [2 /*return*/, getServerUrl(p, hostName, consumer)];
    });
  });
};

exports.getReqConfig = getReqConfig;
exports.getUrl = getUrl;
exports.getUserAgent = getUserAgent;
